<template>
    <div>
        <app-layout v-if="!formDataShow">
            <template v-slot:header>
                <Header :title="$t('leave_of_absence_title')"
                        :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('leave_of_absence_title')"
                              :isFilter="false"/>
            </template>
            <div class="row data-form">
                <div class="col-12" v-if="isInternational">
                    <b-alert variant="info" show>
                        <p v-html="$t('leave_of_absence_international_info')"></p>
                    </b-alert>
                </div>
                <div class="col-12">
                    <div class="mb-4">
                        <h6 class="text-uppercase mb-0">{{ $t('student_information').toUpper() }}</h6>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('student_number_long')">{{ leaveStudentData.student_number }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('name_surname')">{{ this.getObjectValue(leaveStudentData, 'full_name') }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('nationality')">{{ leaveStudentData.nationality }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('faculty')">{{ leaveStudentData.faculty_name }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('class')">{{ leaveStudentData.class }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('program')">{{ leaveStudentData.program_name }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('email')">{{ this.getObjectValue(leaveStudentData, 'email') }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('gsm_no')">{{ this.getObjectValue(leaveStudentData, 'mobile_tel') }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('address')">{{ this.getObjectValue(leaveStudentData, 'address') }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('before_leave_of_absence')">{{ leaveStudentData.before_leave_of_absence }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('leave_of_absence_count')">{{ this.getObjectValue(leaveStudentData, 'leave_of_absence_count') }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('academic_year')">{{ this.getObjectValue(leaveStudentData, 'leave_of_absence_academic_year') }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('legal_presence_type')">{{ this.getObjectValue(leaveStudentData, 'legal_presence_type') }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('registration_type')">{{ this.getObjectValue(leaveStudentData, 'registration_type') }}</b-form-group>
                </div>
            </div>
            <b-form-group>
                <b-button variant="outline-primary" @click="openSmsVerify">{{ $t('update_info_btn').toUpper() }}</b-button>
            </b-form-group>
            <hr>
            <div>
                <b-alert variant="info" show>{{ $t('leave_of_absence_info') }}</b-alert>
            </div>
            <div class="mb-4">
                <h6 class="text-uppercase mb-0">{{ $t('application_information').toUpper() }}</h6>
            </div>
            <ValidationObserver ref="leaveForm">
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                        <ValidationProvider name="leaveOfAbsencePeriod" rules="required" v-slot="{valid, errors}">
                            <b-form-group class="mb-0" :label="$t('leave_of_absence_period')"></b-form-group>
                            <div class="row">
                                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6" v-if="leaveStudentData.leave_of_absence_fall == 1">
                                    <b-form-group>
                                        <b-form-radio v-model="leaveForm.period" value="1">
                                            <span>{{ $t('fall') }} {{ leaveStudentData.leave_of_absence_academic_year }}</span>
                                        </b-form-radio>
                                    </b-form-group>
                                </div>
                                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6" v-if="leaveStudentData.leave_of_absence_summer == 1">
                                    <b-form-group>
                                        <b-form-radio v-model="leaveForm.period" value="3">
                                            <span>{{ $t('summer') }} {{ leaveStudentData.leave_of_absence_academic_year }}</span>
                                        </b-form-radio>
                                    </b-form-group>
                                </div>
                                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6" v-if="leaveStudentData.leave_of_absence_spring == 1">
                                    <b-form-group>
                                        <b-form-radio v-model="leaveForm.period" value="2">
                                            <span>{{ $t('spring') }} {{ leaveStudentData.leave_of_absence_academic_year }}</span>
                                        </b-form-radio>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </ValidationProvider>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                        <ValidationProvider name="leaveOfAbsenceReason" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('leave_of_absence_reason')">
                                <parameter-selectbox v-model="leaveForm.reason"
                                                     code="leave_of_absence_reasons"
                                                     :validate-error="errors[0]"
                                                     :withoutItems="explanationWithoutItems"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3" v-if="isInternational">
                        <ValidationProvider name="departure_date" rules="" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('departure')">
                                <select-date v-model="leaveForm.departure_date"
                                             :validation-error="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3" v-if="isInternational">
                        <ValidationProvider name="end_date" rules="" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('end_date')">
                                <select-date v-model="leaveForm.end_date"
                                             :validation-error="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                        <ValidationProvider name="explanation" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('explanation')">
                                <b-form-textarea v-model="leaveForm.explanation"
                                                 no-resize
                                                 :state="errors[0] ? false : (valid ? true : null)"
                                                 rows="4"
                                                 class="h-40 h-auto-sm"
                                                 maxlength="100"></b-form-textarea>
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                        <ValidationProvider name="excuseFile" :rules="leaveForm.reason == 'military' || leaveForm.reason == 'sickness' ? 'required' : ''" v-slot="{valid, errors}">
                            <b-form-group :label="$t('supporting_document')">
                                <div class="d-flex custom-file-upload">
                                    <b-form-file v-model="leaveForm.files"
                                                 accept=".jpg,.jpeg,.pdf,.doc,.docx"
                                                 :state="errors[0] ? false : (valid ? true : null)"
                                                 :placeholder="$t('select_file')"
                                                 :drop-placeholder="$t('drop_file')"
                                                 ref="fileInput"
                                                 multiple></b-form-file>
                                    <b-button variant="outline-secondary" @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}</b-button>
                                    <b-button variant="outline-secondary" class="btn-40" v-b-popover.hover.bottom="'Yükle'"><i class="ri-upload-2-line"></i></b-button>
                                </div>
                                <div class="text-muted small mt-1">
                                    {{ $t('allowed_file_types') }}
                                </div>
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12 mb-3" v-if="isInternational">
                        <div class="border rounded p-2">
                            <div v-html="$t('leave_of_absence_international_legal_text')"></div>
                        </div>
                    </div>
                    <div class="col-12 mb-3">
                        <ValidationProvider name="isTermsApproved" rules="required" v-slot="{ errors }">
                            <b-form-checkbox v-model="leaveForm.termsConfirmed" :state="errors[0] ? false : null">
                                {{ $t('leave_of_absence_terms_label') }}
                            </b-form-checkbox>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </ValidationProvider>
                    </div>
                </div>
                <b-form-group>
                    <b-button variant="primary" @click="openModalClick">{{ $t('save') }}</b-button>
                </b-form-group>
            </ValidationObserver>
            <CommonModal :size="'xl'" ref="verifyModal">
                <template v-slot:CommonModalTitle>
                    <div>{{ $t('attention') }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <div>
                        <b-form-group style="white-space: pre-wrap">
                            <span v-if="studentProgramLevel == 'YL' || studentProgramLevel == 'D'">
                                {{ $t('leave_of_absence_verify_text_graduate') }}
                            </span>
                            <span v-else>
                                {{ $t('leave_of_absence_verify_text') }}
                            </span>
                        </b-form-group>
                        <div class="d-flex">
                            <b-button variant="primary" class="mr-3" @click="sendLeaveForm">
                                <b-spinner label="Spinning" class="align-middle mr-2" small v-show="updated"></b-spinner>
                                {{ $t('yes') }}
                            </b-button>
                            <b-button type="submit" variant="outline-secondary" @click="$refs.verifyModal.$refs.commonModal.hide()">{{ $t('no') }}</b-button>
                        </div>
                    </div>
                </template>
            </CommonModal>
            <CommonModal ref="gsmVerifyModal">
                <template v-slot:CommonModalTitle>
                    <div>{{ $t('mobile_number_update') }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <div>
                        <ValidationObserver ref="mobileForm">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                    <ValidationProvider name="gsmNo" rules="required" v-slot="{valid, errors}">
                                        <b-form-group :label="$t('mobile_number')">
                                            <b-form-input
                                                v-mask="'+1 (###)-###-####'"
                                                v-model="gsmVerifyForm.gsmNo"
                                                :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between" :class="[{'mb-4' : forgotPass},{'mb-0' : forgotPass}]">
                                <b-button type="submit" variant="primary" @click="infoUpdate()" v-show="smsSendButtonStatus">{{ $t('send') }}</b-button>
                                <b-button type="submit" variant="outline-primary" @click="AddressUpdateClick" v-show="smsSendButtonStatus">{{ $t('address_update') }}</b-button>
                            </div>
                        </ValidationObserver>
                        <div class="visibility-hidden overflow-hidden h-0 fade" :class="[{'visibility-visible, h-auto' : forgotPass},{'show' : forgotPass}]">
                            <b-alert :variant="alertVariant" :show="alertShow"><span v-if="alertVariant == 'success'">{{ $t('verify_code_again_not') }}</span> <span
                                v-if="alertVariant == 'danger'">{{ $t('send_again_not') }}</span></b-alert>
                            <ValidationObserver ref="smsVerifyActionForm">
                                <div class="mb-3">
                                    <ValidationProvider name="smsVerifyCode" rules="required" v-slot="{valid, errors}">
                                        <b-form-group>
                                            <div class="d-flex justify-content-between align-items-center">
                                                <label class="col-form-label">{{ $t('verification_code') }}</label>
                                                <div class="text-muted"><i class="ri-time-line top-plus-2 mr-1"></i>{{ timerCount }} sn</div>
                                            </div>
                                            <b-form-input
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                v-model="smsVerifyActionForm.verifyCode"></b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>

                                <div class="d-flex justify-content-between">
                                    <b-button type="submit" variant="primary" @click="gsmVerify">{{ $t('verify') }}</b-button>
                                    <b-button type="submit" variant="outline-secondary" @click="EnterCodeAgainFunc()" v-show="smsSendAgainButtonStatus">{{ $t('send_again_btn') }}
                                    </b-button>
                                </div>
                            </ValidationObserver>
                        </div>
                    </div>
                </template>
            </CommonModal>
            <CommonModal ref="addressModal">
                <template v-slot:CommonModalTitle>
                    <div>{{ $t('address_update') }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <div>
                        <ValidationObserver ref="addressForm">
                            <div class="row">
                                <div class="col-12 col-md-12">
                                    <ValidationProvider name="state" rules="required" v-slot="{valid, errors}">
                                        <b-form-group>
                                            <label>{{ $t('state') }}</label>
                                            <state-selectbox
                                                :validateError="errors[0]"
                                                v-model="addressForm.state"></state-selectbox>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-md-12">
                                    <ValidationProvider name="city" rules="required" v-slot="{valid, errors}">
                                        <b-form-group>
                                            <label>{{ $t('city') }}</label>
                                            <city-selectbox
                                                :validateError="errors[0]"
                                                :state_id="addressForm.state"
                                                v-model="addressForm.city"></city-selectbox>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-md-12">
                                    <ValidationProvider name="address" rules="required" v-slot="{valid, errors}">
                                        <b-form-group>
                                            <label>{{ $t('address') }}</label>
                                            <b-form-textarea no-resize
                                                             v-model="addressForm.address"
                                                             :state="errors[0] ? false : (valid ? true : null)"
                                                             rows="4"
                                                             class="h-40 h-auto-sm"
                                                             maxlength="100"></b-form-textarea>
                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between">
                                <b-button type="submit" variant="primary" @click="addressUpdate">{{ $t('update') }}</b-button>
                            </div>
                        </ValidationObserver>
                    </div>
                </template>
            </CommonModal>
        </app-layout>
        <app-layout v-if="formDataShow">
            <template v-slot:header>
                <Header :title="$t('leave_of_absence_title')"
                        :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('leave_of_absence_title')"
                              :isFilter="false"/>
            </template>
            <div class="row">
                <div class="col-12 col-md-12 col-xl-12 col-xxl-12">
                    <b-alert show variant="danger">{{ formDataShow }}</b-alert>
                </div>
            </div>
        </app-layout>
    </div>
</template>
<script>
    // Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header';
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile';

    // Component
    import CommonModal from '@/components/elements/CommonModal';
    import StateSelectbox from '@/components/interactive-fields/StateSelectbox';
    import CitySelectbox from '@/components/interactive-fields/CitySelectbox'
    import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox';

    // Services
    import LeaveOfAbsenceService from '@/services/LeaveOfAbsenceService';
    import PersonService from '@/services/PersonService';

    // Other
    import {ValidationObserver, ValidationProvider} from 'vee-validate';
    import isset from 'isset-php'

    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile,

            StateSelectbox,
            CommonModal,
            CitySelectbox,
            ParameterSelectbox,
            ValidationProvider,
            ValidationObserver
        },
        data() {
            return {
                user: {},

                formDataShow: false,
                updated: false,
                leaveStudentData: {},
                periodOptions: [
                    {name: 'Güz', id: 1},
                    {name: 'Bahar', id: 2}
                ],
                leaveForm: {
                    period: null,
                    reason: null,
                    explanation: null,
                    files: null,
                    accepted: null,
                    termsConfirmed: null,
                    departure_date: null,
                    end_date: null,
                },
                gsmVerifyForm: {
                    gsmNo: null
                },

                smsSendButtonStatus: true,
                smsSendAgainButtonStatus: false,
                alertVariant: 'success',
                alertShow: true,
                forgotPass: false,
                timerCount: 5,

                smsVerifyActionForm: {
                    verifyCode: null
                },

                addressForm: {
                    state: null,
                    city: null,
                    address: null
                }
            }
        },
        metaInfo() {
            return {
                title: this.$t('leave_of_absence_title')
            }
        },
        computed: {
            explanationWithoutItems() {
                const user = this.$store.getters['auth/getUser'];
                const hide = [];

                if (isset(() => user.person.gender) && user.person.gender === 'Kadın') {
                    hide.push('military');
                }

                if (isset(() => user.customer_group) && user.customer_group === 'INTERNATIONAL') {
                    hide.push('financial');
                }

                return hide.join(',');
            },
            studentProgramLevel() {
                return this.$store.getters['auth/getUser']?.active_student_program?.program_level ?? '';
            },
            isInternational() {
                return this.$store.getters['auth/getUser']?.customer_group === 'INTERNATIONAL';
            }
        },

        methods: {
            getFormData() {
                LeaveOfAbsenceService.getLeaveForm()
                                     .then(response => {
                                         this.leaveStudentData = response.data.data
                                         this.gsmVerifyForm.gsmNo = this.leaveStudentData.mobile_tel
                                         this.getAddress()

                                         if(this.leaveStudentData.leave_of_absence_fall == 1) {
                                             this.leaveForm.period = "1" // push yerine direkt eşitleme
                                         } else if(this.leaveStudentData.leave_of_absence_spring == 1) {
                                             this.leaveForm.period = "2"
                                         } else if(this.leaveStudentData.leave_of_absence_summer == 1) {
                                             this.leaveForm.period = "3"
                                         }
                                     })
                                     .catch(e => {
                                         this.formDataShow = this.$t('api.' + e.data.message)
                                     })
            },
            getAddress() {
                PersonService.getAddress()
                             .then(response => {
                                 let data = response.data.data
                                 this.addressForm.state = data.contact_state_id
                                 this.addressForm.city = data.contact_city_id
                                 this.addressForm.address = data.contact_address
                                 this.leaveStudentData.address = data.contact_address
                                 if (data.contact_state_name) {
                                     this.leaveStudentData.address += ' ' + data.contact_state_name;
                                 }
                                 if (data.contact_city_name) {
                                     this.leaveStudentData.address += ' / ' + data.contact_city_name;
                                 }
                             })
            },

            customLabel(value) {
                return value;
            },

            async openModalClick() {
                const isValidLeave = await this.$refs.leaveForm.validate();
                if (isValidLeave) {
                    this.$refs.verifyModal.$refs.commonModal.show()
                }

            },

            async sendLeaveForm() {
                this.updated = true
                const period = this.leaveForm.period;

                let formData = new FormData()
                formData.append('explanation', this.leaveForm.explanation)
                formData.append('status', 'pending')
                formData.append('fall', period == "1" ? 1 : 0)
                formData.append('spring', period == "2" ? 1 : 0)
                formData.append('summer', period == "3" ? 1 : 0)
                formData.append('reason', this.leaveForm.reason)
                formData.append('accepted', 1)

                const files = Array.isArray(this.leaveForm.files)
                    ? this.leaveForm.files
                    : (this.leaveForm.files ? [this.leaveForm.files] : []);

                files.forEach(f => formData.append('files[]', f));

                if(this.isInternational && this.leaveForm.departure_date) {
                    formData.append('departure_date', this.leaveForm.departure_date)
                }

                if(this.isInternational && this.leaveForm.end_date) {
                    formData.append('end_date', this.leaveForm.end_date)
                }

                LeaveOfAbsenceService.storeLeaveForm(formData).then(response => {
                    if (response.status === 200) {
                        this.$refs.verifyModal.$refs.commonModal.hide()
                        this.$toast.success(this.$t('api.' + response.data.message))
                        this.$router.push('/my-requests/0') /// send to 0. tab
                    }
                }).catch(e => {
                    if (e.status == '404' || e.status == '406') { ///406 geldiği zaman değiştirilecek
                        if (e.data.message) {
                            this.$refs.verifyModal.$refs.commonModal.hide()
                            this.$refs.leaveForm.errors.leaveOfAbsencePeriod.push(this.$t('api.' + e.data.message));
                            this.$toast.error(this.$t('api.' + e.data.message));
                        }
                    }
                    /*
                     else if (e.status == 420){
                     this.$swal.fire({
                     text: this.$t('api.' + e.data.message),
                     showCancelButton: true,
                     confirmButtonText: this.$t('yes'),
                     cancelButtonText: this.$t('no')
                     })
                     .then((result) => {
                     this.leaveForm.accepted=0;
                     if (result.isConfirmed) {
                     this.leaveForm.accepted=1;
                     this.sendLeaveForm();
                     }
                     })
                     }
                     */
                    else {
                        if (e.data.errors.explanation) {
                            this.$refs.leaveForm.errors.explanation.push(e.data.errors.explanation[0]);
                        }
                        if (e.data.errors.fall) {
                            this.$refs.leaveForm.errors.leaveOfAbsencePeriod.push(e.data.errors.fall[0]);
                        }
                        if (e.data.errors.spring) {
                            this.$refs.leaveForm.errors.leaveOfAbsencePeriod.push(e.data.errors.spring[0]);
                        }
                        if (e.data.errors.summer) {
                            this.$refs.leaveForm.errors.leaveOfAbsencePeriod.push(e.data.errors.summer[0]);
                        }
                        if (e.data.errors.reason) {
                            this.$refs.leaveForm.errors.leaveOfAbsenceReason.push(e.data.errors.reason[0]);
                        }
                        if (e.data.errors.student_program_id) {
                            this.$refs.leaveForm.errors.leaveOfAbsencePeriod.push(e.data.errors.student_program_id[0]);
                        }
                        if (e.data.errors.files) {
                            this.$refs.leaveForm.errors.excuseFile.push(e.data.errors.files[0]);
                        }

                        this.updated = false
                        this.$refs.verifyModal.$refs.commonModal.hide()
                    }
                })

            },

            openSmsVerify() {
                this.$refs.gsmVerifyModal.$refs.commonModal.show()
            },

            async infoUpdate() {
                const isValid = await this.$refs.mobileForm.validate();
                if (isValid) {
                    let gsmData = {
                        mobile_tel: this.gsmVerifyForm.gsmNo
                    }

                    PersonService.sendSmsCode(gsmData).then(response => {
                        let data = response.data.data;
                        this.forgotPass = true
                        this.timerCount = data.expires_in
                        this.timerEnabled = true
                        this.smsSendButtonStatus = false
                        this.smsSendAgainButtonStatus = false
                    }).catch(e => {
                        this.showErrors(e,this.$refs.mobileForm)
                    })
                }

            },

            async gsmVerify() {

                const isValid = await this.$refs.smsVerifyActionForm.validate();
                if (isValid) {
                    let smsData = {
                        sms_code: this.smsVerifyActionForm.verifyCode
                    }
                    PersonService.verifySmsCode(smsData).then(response => {

                        let data = response.data;
                        if (data.success == false) {
                            this.$refs.smsVerifyActionForm.errors.smsVerifyCode.push(data.message);
                        }
                        else {
                            this.$refs.gsmVerifyModal.$refs.commonModal.hide()
                            this.leaveStudentData.mobile_tel = this.gsmVerifyForm.gsmNo
                            this.$toast.success(this.$t('api.' + data.message));
                            this.$refs.emailVerifyModal.$refs.commonModal.show()
                        }
                    })
                }
            },

            EnterCodeAgainFunc() {
                this.alertVariant = 'success'
                this.infoUpdate()
            },

            AddressUpdateClick() {
                this.$refs.addressModal.$refs.commonModal.show()
                this.$refs.gsmVerifyModal.$refs.commonModal.hide()
            },

            async addressUpdate() {
                const isValid = await this.$refs.addressForm.validate();
                if (isValid) {
                    let addressData = {
                        contact_address: this.addressForm.address,
                        contact_state_id: this.addressForm.state,
                        contact_city_id: this.addressForm.city
                    }

                    PersonService.patchAddress(addressData)
                                 .then(response => {
                                     let data = response.data
                                     this.$toast.success(this.$t('api.' + data.message));
                                     this.$refs.addressModal.$refs.commonModal.hide()
                                     this.getAddress()
                                 })
                                 .catch(e => {
                                     this.showErrors(e,this.$refs.addressForm)
                                 })
                }
            }
        },
        created() {
            this.getFormData()
        },

        watch: {
            timerEnabled(value) {
                this.timerCount--;
            },
            timerCount: {
                handler(value) {
                    if (value > 0 && this.timerEnabled) {
                        setTimeout(() => {
                            this.timerCount--;
                        }, 1000);
                    }
                    else if (value > 0 && !this.timerEnabled) {
                        this.alertShow = false
                        this.smsSendAgainButtonStatus = false
                    }
                    else {
                        this.alertVariant = 'danger'
                        this.alertShow = true
                        this.smsSendAgainButtonStatus = true
                    }
                },
                immediate: true
            },
            timerEnabledEmail(value) {
                this.timerCountEmail--;
            },
            timerCountEmail: {
                handler(value) {
                    if (value > 0 && this.timerEnabledEmail) {
                        setTimeout(() => {
                            this.timerCountEmail--;
                        }, 1000);
                    }
                    else if (value > 0 && !this.timerEnabledEmail) {
                        this.alertShowEmail = false
                        this.smsSendAgainButtonStatus = false
                    }
                    else {
                        this.alertVariantEmail = 'danger'
                        this.alertShowEmail = true
                        this.emailSendAgainButtonStatus = true
                    }

                },
                immediate: true
            }
        }
    };
</script>
